var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "progressive-image",
      class: _vm.absolute ? "absolute" : "relative",
      style: _vm.style
    },
    [
      _c("transition", { attrs: { name: "progressive-image" } }, [
        _vm.shouldLoad
          ? _c("img", {
              staticClass: "progressive-image__image",
              style: { backgroundColor: _vm.backgroundColor },
              attrs: {
                sizes: _vm.sizes,
                srcset: _vm.imageObject.srcSet,
                src: _vm.imageObject.src,
                alt: _vm.altText
              }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }